export const RouteLinks = {
  Login: "/login",
  Overview: "/dashboard-overview",
  Transactions: "/dashboard-transactions",
  Insights: "/dashboard-insights",
  Terminals: "/dashboard-terminals",
  Terminal_details: "/dashboard-single-terminal-details",
  Terminal_request_details: "/dashboard-single-terminal-request-details",
  Settings: "/dashboard-settings",
  Settings_business_profile: "/dashboard-settings-business-profile",
  Settings_cac_verification: "/dashboard-settings-cac-verification",
  Settings_settlement_account: "/dashboard-settings-settlement-account",
  Request_Terminal: "/dashboard-terminals-request",
  Terminals_Virtual: "/dashboad-terminals-virtual",
  Physical_Terminal: "/dashboard-terminals-physical",
  Terminal_Virtual_List: "/dashboad-terminal-virtual",
  Request_Virtual_Terminal_display: "/dashboard-virtual-terminal-request-details",
  AllRequested_Terminal:  "/dashboard-terminal-requests",
  Physical_Terminal_list: "/dashboard-terminal-physical"
};
